import dayjs from "@webapp/shared/libs/dayjs";
import { CHART_POINT_DATE_FORMAT } from "../kpi-details/kpi-chart/utils";

export function shouldShowInfoIcon(targetType: string, targetDate: string): boolean {
  if (targetType !== "kpi_snapshot") {
    return false;
  }

  const todayFormatted = dayjs().format(CHART_POINT_DATE_FORMAT);
  const targetDateFormatted = dayjs(targetDate).format(CHART_POINT_DATE_FORMAT);

  return todayFormatted === targetDateFormatted;
}
